<!-- @format -->

<template>
    <v-list class="gst-list pt-0">
        <v-list-item
            v-for="(item, index) in items"
            :key="index"
            class="gst-list__item px-0 py-4"
            :to="{ name: 'venue', params: { id: item.id } }">
            <VenueCardSmall
                :venue="item"
                class="u-background-transparent u-width-100" />
        </v-list-item>
    </v-list>
</template>

<script>
import VenueCardSmall from '@tenant/app/components/venue/VenueCardSmall.vue';

export default {
    name: 'SearchResultTabsVenuesList',
    components: {
        VenueCardSmall,
    },
    props: {
        items: {
            type: Array,
            default: null,
        },
    },
};
</script>
